import { DataSignal } from "s-js";
import * as Surplus from "surplus";
import { InputCheckbox, InputState } from "surplus-forms";

type SwitchCheckboxProps = {
    data: DataSignal<InputState<boolean>>;
    /** Second label to show when toggle is in off position */
    labelOff?: string;
    label: string;
    required?: boolean;
    showBefore?: boolean;
};

export function SwitchCheckbox(props: SwitchCheckboxProps) {
    const propsShowBefore = props.showBefore,
        propsLabel = props.label,
        propsLabelOff = props.labelOff;
    cleanupProps();

    return (
        <label class="cur-ptr " for={props.data().name} onMouseDown={preventEventDefault}>
            {propsShowBefore && (
                <span class="toggleLabel  toggleLabelBefore">
                    {props.data().value ? propsLabel : propsLabelOff || propsLabel}
                </span>
            )}
            <InputCheckbox class="toggle-switch" {...props} />
            {(!propsShowBefore && (
                <span class="toggleLabel toggleLabelAfter">
                    {props.data().value ? propsLabel : propsLabelOff || propsLabel}
                </span>
            )) || <span />}
        </label>
    );

    function cleanupProps() {
        delete props.showBefore;
        delete props.labelOff;
        delete (props as any).label;
    }

    function preventEventDefault(e: MouseEvent) {
        e.preventDefault();
    }
}
